import React from 'react';

import { ContinueButtonProps } from '../types/auth';

import '../styles/auth.css';

import { LoadingSpinner } from './LoadingSpinner';

export const ContinueButton: React.FC<ContinueButtonProps> = ({
  onClick,
  isLoading,
  disabled,
  children,
}) => (
  <button
    type="button"
    className="continue-button btn btn-outline"
    onClick={onClick}
    disabled={disabled || isLoading}
  >
    {isLoading ? <LoadingSpinner size={20} /> : children}
  </button>
);
